// Remembers where to send the user after they start a trial / purchase from the
// upload blocker, so they land back on the exact page they were uploading from
// (e.g. /gift-content) and can continue — instead of the default dashboard.
//
// Only the upload-blocker CTA writes this key, and it is read-and-cleared once
// on a successful purchase, so every other purchase flow is unaffected (peek()
// returns null there and callers fall back to their normal destination). A TTL
// guards against a stale value (user abandons /plans) misrouting a much-later
// unrelated purchase in the same tab.
const KEY = 'postPurchaseReturnUrl';
const MAX_AGE_MS = 30 * 60 * 1000; // 30 minutes

export const savePostPurchaseReturn = (url) => {
  try {
    if (url) sessionStorage.setItem(KEY, JSON.stringify({ url, ts: Date.now() }));
  } catch (e) {
    /* sessionStorage unavailable — no-op */
  }
};

// Read the saved return URL WITHOUT clearing it (returns null if missing or
// expired, clearing an expired one). Safe for handlers that may run more than
// once per purchase — they all resolve to the same target.
export const peekPostPurchaseReturn = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const { url, ts } = JSON.parse(raw);
    if (!url || !ts || Date.now() - ts > MAX_AGE_MS) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return url;
  } catch (e) {
    return null;
  }
};

export const clearPostPurchaseReturn = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    /* no-op */
  }
};
